import { FC } from "react";

type Props = {
  children: React.ReactNode;
};

const Home: FC<Props> = ({ children }) => {
  return (
    <div className="mx-auto flex w-full max-w-[1100px] flex-col p-[24px]">
      {children}
    </div>
  );
};

export default Home;
